import { render } from "./PasswordScreen.vue?vue&type=template&id=35aaab32&scoped=true"
import script from "./PasswordScreen.vue?vue&type=script&lang=js"
export * from "./PasswordScreen.vue?vue&type=script&lang=js"

import "./PasswordScreen.vue?vue&type=style&index=0&id=35aaab32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35aaab32"]])

export default __exports__